import { render, staticRenderFns } from "./EditMailNotification.vue?vue&type=template&id=19f31d89&scoped=true"
import script from "./EditMailNotification.vue?vue&type=script&lang=js"
export * from "./EditMailNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f31d89",
  null
  
)

export default component.exports